export const booksCollection = [
  // --- STOICISM & RESILIENCE ---
  {
    id: 1, title: "Meditations", author: "Marcus Aurelius", category: "Stoicism",
    cover: "https://m.media-amazon.com/images/I/81K+-7T-7JL._AC_UF1000,1000_QL80_.jpg",
    desc: "Notes to himself on how to stay calm in chaos.",
    chapters: [{ title: "Book I", content: "You have power over your mind - not outside events. Realize this, and you will find strength." }]
  },
  {
    id: 2, title: "Enchiridion", author: "Epictetus", category: "Stoicism",
    cover: "https://m.media-amazon.com/images/I/71wE5r3tVIL._AC_UF1000,1000_QL80_.jpg",
    desc: "A manual for a peaceful life.",
    chapters: [{ title: "Chapter 1", content: "Some things are in our control and others not." }]
  },
  {
    id: 3, title: "Self-Reliance", author: "Ralph Waldo Emerson", category: "Self-Help",
    cover: "https://m.media-amazon.com/images/I/61F5p+5YcRL._AC_UF1000,1000_QL80_.jpg",
    desc: "Trusting your own intuition.",
    chapters: [{ title: "Trust Thyself", content: "To believe your own thought, to believe that what is true for you in your private heart is true for all men." }]
  },

  // --- PSYCHOLOGY & MINDSET ---
  {
    id: 4, title: "As a Man Thinketh", author: "James Allen", category: "Mindset",
    cover: "https://m.media-amazon.com/images/I/81+MSrQvO-L._AC_UF1000,1000_QL80_.jpg",
    desc: "How thoughts shape reality.",
    chapters: [{ title: "Thought & Character", content: "A man is literally what he thinks, his character being the complete sum of all his thoughts." }]
  },
  {
    id: 13, title: "The Varieties of Religious Experience", author: "William James", category: "Psychology",
    cover: "https://m.media-amazon.com/images/I/81+J-z-5l+L._AC_UF1000,1000_QL80_.jpg",
    desc: "A study in human nature.",
    chapters: [{ title: "Religion and Neurology", content: "The psychological basis of religious experience." }]
  },
  {
    id: 6, title: "Dream Psychology", author: "Sigmund Freud", category: "Psychology",
    cover: "https://m.media-amazon.com/images/I/71+7-1X+5+L._AC_UF1000,1000_QL80_.jpg",
    desc: "Psychoanalysis for beginners.",
    chapters: [{ title: "Dreams have a Meaning", content: "In what we may term 'prescientific days' people were in no uncertainty about the interpretation of dreams." }]
  },

  // --- SPIRITUALITY ---
  {
    id: 7, title: "Siddhartha", author: "Hermann Hesse", category: "Spirituality",
    cover: "https://m.media-amazon.com/images/I/91tU+d1Hw+L._AC_UF1000,1000_QL80_.jpg",
    desc: "A journey of self-discovery.",
    chapters: [{ title: "The Brahmin's Son", content: "In the shade of the house, in the sunshine of the riverbank near the boats, Siddhartha grew up." }]
  },
  {
    id: 8, title: "The Prophet", author: "Kahlil Gibran", category: "Spirituality",
    cover: "https://m.media-amazon.com/images/I/71ScG7g2BTL._AC_UF1000,1000_QL80_.jpg",
    desc: "Poetic essays on life.",
    chapters: [{ title: "On Pain", content: "Your pain is the breaking of the shell that encloses your understanding." }]
  },
  {
    id: 9, title: "Tao Te Ching", author: "Lao Tzu", category: "Spirituality",
    cover: "https://m.media-amazon.com/images/I/714+4-1+1+L._AC_UF1000,1000_QL80_.jpg",
    desc: "The book of the way.",
    chapters: [{ title: "Chapter 1", content: "The Tao that can be told is not the eternal Tao." }]
  },

  // --- LITERATURE & CALM ---
  {
    id: 10, title: "Walden", author: "Henry David Thoreau", category: "Nature",
    cover: "https://m.media-amazon.com/images/I/71O+5+8+8+L._AC_UF1000,1000_QL80_.jpg",
    desc: "Simple living in nature.",
    chapters: [{ title: "Where I Lived", content: "I went to the woods because I wished to live deliberately." }]
  },
  {
    id: 14, title: "The Yellow Wallpaper", author: "Charlotte Perkins Gilman", category: "Fiction",
    cover: "https://m.media-amazon.com/images/I/61N+6l+3+IL._AC_UF1000,1000_QL80_.jpg",
    desc: "A classic on mental health.",
    chapters: [{ title: "The Journal", content: "It is very seldom that mere ordinary people like John and myself secure ancestral halls for the summer." }]
  },
  {
    id: 15, title: "Metamorphosis", author: "Franz Kafka", category: "Fiction",
    cover: "https://m.media-amazon.com/images/I/71Xq+K+3+IL._AC_UF1000,1000_QL80_.jpg",
    desc: "Alienation and identity.",
    chapters: [{ title: "Part I", content: "One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin." }]
  },
  {
    id: 16, title: "Notes from Underground", author: "Fyodor Dostoevsky", category: "Philosophy",
    cover: "https://m.media-amazon.com/images/I/71s+3+IL._AC_UF1000,1000_QL80_.jpg",
    desc: "Existentialist philosophy.",
    chapters: [{ title: "Part I", content: "I am a sick man... I am a spiteful man. I am an unattractive man. I believe my liver is diseased." }]
  },
  {
    id: 12, title: "Leaves of Grass", author: "Walt Whitman", category: "Poetry",
    cover: "https://m.media-amazon.com/images/I/81+9+8+8+L._AC_UF1000,1000_QL80_.jpg",
    desc: "Celebrating nature.",
    chapters: [{ title: "Song of Myself", content: "I celebrate myself, and sing myself." }]
  }
];